var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEasyPortal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_171_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 0H57.4526V87.5475H145V0Z",
    fill: "url(#paint0_linear_171_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.638 14.3647H43.0908V101.912H130.638V14.3647Z",
    fill: "url(#paint1_linear_171_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.274 28.7263H28.7263V116.274H116.274V28.7263Z",
    fill: "url(#paint2_linear_171_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.912 43.0908H14.3647V130.638H101.912V43.0908Z",
    fill: "url(#paint3_linear_171_58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5475 57.4526H0V145H87.5475V57.4526Z",
    fill: "url(#paint4_linear_171_58)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171_58",
    x1: 57.4526,
    y1: 43.7722,
    x2: 145,
    y2: 43.7722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_171_58",
    x1: 43.0908,
    y1: 58.137,
    x2: 130.635,
    y2: 58.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_171_58",
    x1: 28.7263,
    y1: 72.4985,
    x2: 116.274,
    y2: 72.4985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_171_58",
    x1: 14.3647,
    y1: 86.863,
    x2: 101.909,
    y2: 86.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_171_58",
    x1: 0,
    y1: 101.228,
    x2: 87.5475,
    y2: 101.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_171_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 145,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyPortal);
export default __webpack_public_path__ + "static/media/easy-portal.1b80c8c8161e06731a0d9ec9084d8a06.svg";
export { ForwardRef as ReactComponent };